import React from 'react';
import { updateHref, ClickLinkDataParamType } from '@rmc/webcx-web-libs';
import styles from './index.module.scss';

export type ActionButtonPropsType = {
	text: string;
	link: string;
	clickLinkData: ClickLinkDataParamType;
	target?: string;
	onClick: () => void;
	style?: React.CSSProperties;
};

export function ActionButton({
	text,
	link,
	clickLinkData,
	onClick,
	target = '_blank',
	style = {},
}: ActionButtonPropsType) {
	const rel = 'noopener noreferrer';
	return (
		<a
			rel={rel}
			className={styles.actionButton}
			onClick={onClick}
			onAuxClick={onClick}
			target={target}
			href={updateHref(clickLinkData, link)}
			style={style}
		>
			{text}
		</a>
	);
}
